import React from "react";
import {
  LineChart as RechartsLineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
} from "recharts";
import PropTypes from "prop-types";

const LineChart = ({ data, xKey = "name", colors = {} }) => {
  if (!Array.isArray(data) || data.length === 0) return null;

  // Get all line keys dynamically (exclude xKey)
  const lineKeys = Object.keys(data[0]).filter((key) => key !== xKey);

  // Get max value for Y axis scaling
  const allValues = data.flatMap((entry) =>
    lineKeys.map((key) => Number(entry[key]) || 0)
  );
  const maxValue = Math.max(...allValues);
  const nearestValue = Math.ceil(maxValue / 10) * 10;

  // Generate horizontal reference lines
  const referenceLines = [];
  for (let i = 10; i <= nearestValue; i += 10) {
    referenceLines.push(
      <ReferenceLine key={i} y={i} stroke="#CFCFCF" strokeWidth={1} />
    );
  }

  return (
    <div style={{ width: "25vw" }}>
      <ResponsiveContainer width="100%" height={200}>
        <RechartsLineChart data={data}>
          <XAxis dataKey={xKey} stroke="#555"  className="t-10 poppins color-grayColor" />
          <YAxis stroke="#555" />
          <Tooltip />
          {lineKeys.map((key) => (
            <Line
              key={key}
              type="linear"
              dataKey={key}
              stroke={colors[key] || "#8884d8"} // Default color if not provided
              strokeWidth={2}
              name={key}
              dot={false}
            />
          ))}
          {referenceLines}
        </RechartsLineChart>
      </ResponsiveContainer>
    </div>
  );
};

LineChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  xKey: PropTypes.string,
  colors: PropTypes.object, // optional: { key1: "#color1", key2: "#color2", ... }
};

export default LineChart;
